module.exports = __webpack_public_path__ + "img/blue-memoryiq.3aece58d.svg";